import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.at.js";
import "core-js/modules/es.string.at-alternative.js";
import { getFactoryErrorApi } from '@/api';
import Multiselect from 'vue-multiselect';
import i18n from '@/lang/lang';
import { dbDataHandle } from '@/store/function/common/index';
import { alarmDownload } from '@/store/function/common/alarmDownload';


import { DateTime } from 'luxon';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
// 跟後端 realtime.controller.js 的 MAX_DAYS_* 一致，依據寫在那邊
var ALARM_MAX_DAYS = {
  single: 31,
  all: 7
};
export default {
  name: 'Realtime',
  components: {
    Multiselect: Multiselect
  },
  data: function data() {
    return {
      whichFactory: '',
      selectedAlert: null,
      exitFunction: false,
      alertPerPage: 10,
      alertCurrentPage: 1,
      searchValue: [],
      // 搜尋資料用，因 multiselectValue 會延遲
      multiselectValue: [],
      alertField: [{
        key: '告警啟動時間',
        sortable: true,
        thClass: 'thClass',
        label: '告警啟動時間'
      }, {
        key: '事件',
        sortable: true,
        thClass: 'thClass',
        label: '事件'
      }],
      modalTitle: '',
      selectTime: DateTime.local().toFormat('yyyy-MM-dd'),
      alertBeginTime: DateTime.local().toFormat('yyyy-MM-dd'),
      alertEndTime: DateTime.local().toFormat('yyyy-MM-dd'),
      allAlertBeginTime: DateTime.local().toFormat('yyyy-MM-dd'),
      allAlertEndTime: DateTime.local().toFormat('yyyy-MM-dd'),
      ALARM_MAX_DAYS: ALARM_MAX_DAYS,
      alarmQueriedRange: [],
      // 畫面上這批告警實際查的區間，下載檔名用
      alertData: [],
      alarmReqSeq: 0,
      // 告警查詢序號：只收最新一次請求的回應，避免開窗中按查詢時兩批結果疊在一起
      alarmLevelsPending: false,
      alertTableLoading: false,
      disabledDates: {
        to: new Date(2020, 11, 28)
      },
      // headColor: 'light',
      tableMode: false,
      alertModalNoData: false,
      isLoadingData: false,
      clientTop: true,
      multipleSearchArray: [],
      alertLevelSelectDisAble: false,
      alertFilterInput: '',
      alertFilterLevelNum: [2],
      // activated 的按鈕 level num list
      hasKeepingAlive: false,
      openGroups: {} // 收折狀態：group key -> 是否展開
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['factoryData', 'overlayShow', 'userDetail', 'factoryInfo', 'roleComponentMenu', 'roleOthersMenu', 'hasRoleAdmin', 'hasDemoPermission', 'hasDemoCallApi', 'alarmAmountData' // 告警數量、案場
  ])), mapGetters(['getFactoryInfoNameList'])), {}, {
    levelButtons: function levelButtons() {
      var _this = this;
      return [{
        level: 2,
        color: 'red',
        text: '影響發電'
      }, {
        level: 9,
        color: 'blue',
        text: '發電效率不佳'
      }, {
        level: 3,
        color: 'yellow',
        text: '不影響發電'
      },
      // { level: 3, color: 'yellow', text: 'RA PR 系統觸發告警' },
      {
        level: 6,
        color: 'grey',
        text: '系統未連線'
      }, {
        level: 7,
        color: 'lavender',
        text: '系統短暫斷線'
      }
      // { level: 8, color: 'blue', text: 'PA PR 系統觸發告警' }
      ].filter(function (obj) {
        return _this.roleOthersMenu[0].list.includes(obj.text);
      }); // 過濾告警按鈕權限
      // 取 othersMenu 的第一個 object [ 即時資訊 - 案場狀態告警 ]
    },
    // 依權限列出 可看 level num list
    hasAlertLevelNumList: function hasAlertLevelNumList() {
      return this.levelButtons.map(function (obj) {
        return obj.level;
      });
    },
    // 案場狀態 chip：依告警等級權限過濾 (hasAlertLevelNumList)
    // 資料缺漏回補(5) 非告警等級權限管控項目，恆顯示
    // 系統正常營運(0) 不列入 chip，點下去會把全部正常案場撈進來，交給「全部載入」處理
    statusChips: function statusChips() {
      var _this2 = this;
      var all = [{
        level: 2,
        text: this.$t('realTime.status.noPowerData'),
        color: '#dc2626',
        icon: require('../assets/electrical.svg'),
        tip: 'Inv 斷訊(null)、Inv 未發電'
      }, {
        level: 9,
        text: this.$t('realTime.status.poorPower'),
        color: '#7c3aed',
        icon: require('../assets/poor-power.svg'),
        tip: '1. Inv 有發電但效率不佳(RA)<br>2. Mppt 不發電或發電不佳<br>3. 保證PR / 保證發電量未達標'
      }, {
        level: 3,
        text: this.$t('realTime.status.partialSystemError'),
        color: '#d97706',
        fa: 'fas fa-radiation-alt',
        tip: '依通訊裝置異常告警數值定義(不含 Inv 斷訊)'
      }, {
        level: 7,
        text: this.$t('realTime.status.deviceDisconnectedShort'),
        color: '#0891b2',
        icon: require('../assets/hourglass.svg'),
        tip: '案場斷網 30 分鐘內'
      }, {
        level: 6,
        text: this.$t('realTime.status.deviceDisconnected'),
        color: '#64748b',
        icon: require('../assets/smart-plug.svg'),
        tip: '案場斷網大於 30 分鐘'
      }, {
        level: 5,
        text: this.$t('realTime.status.backfill'),
        color: '#2563eb',
        icon: require('../assets/file-error.svg'),
        tip: '停電後 Buffer 回補、斷網後計算回補、特殊計算回補、三日內無資料'
      }];
      return all.filter(function (c) {
        return c.level === 5 || _this2.hasAlertLevelNumList.includes(c.level);
      });
    },
    hasAllFactoryPermission: function hasAllFactoryPermission() {
      return this.userDetail.factoriesList.includes('ALL');
    },
    filterSearch: function filterSearch() {
      var _this3 = this;
      // 這裡用 multiselectValue 作為篩選

      // no alert no select
      if (!this.selectedAlert && this.multiselectValue.length === 0) {
        return this.factoryData;
      }

      // only select
      if (!this.selectedAlert && this.multiselectValue.length !== 0) {
        return this.factoryData.filter(function (data) {
          return _this3.multiselectValue.includes(data.displaySiteName);
        });
      }

      // only alert
      if (this.selectedAlert && this.multiselectValue.length === 0) {
        return this.factoryData.filter(function (data) {
          return _this3.selectedAlert.includes(data.displayAlertLevel);
        });
      }

      // alert && select
      return this.factoryData.filter(function (data) {
        return _this3.multiselectValue.includes(data.displaySiteName) && _this3.selectedAlert.includes(data.displayAlertLevel);
      });
    },
    // 總告警顯示
    filteredAlertData: function filteredAlertData() {
      var _this4 = this;
      if (this.alertFilterInput === '') {
        return this.alertData.filter(function (obj) {
          return _this4.hasAlertLevelNumList.includes(obj['等級']);
        });
      }
      return this.alertData.filter(function (obj) {
        return obj['事件'].match(_this4.alertFilterInput) && _this4.hasAlertLevelNumList.includes(obj['等級']);
      });
    },
    // table 顯示的
    showFilteredAlertData: function showFilteredAlertData() {
      var _this5 = this;
      // has input & click level button
      if (this.alertFilterInput !== '' && this.alertFilterLevelNum.length) {
        return this.alertData.filter(function (item) {
          return item['事件'].match(_this5.alertFilterInput) && _this5.hasAlertLevelNumList.includes(item['等級']) &&
          // 權限 可看 level num list
          _this5.alertFilterLevelNum.includes(item['等級']);
        } // activated 的按鈕 level num list
        );
      }

      // click level button
      if (this.alertFilterLevelNum.length) {
        return this.alertData.filter(function (item) {
          return _this5.hasAlertLevelNumList.includes(item['等級']) && _this5.alertFilterLevelNum.includes(item['等級']);
        });
      }

      // 無選任何等級按鈕 → 顯示所有（依權限過濾）
      return this.filteredAlertData;
    },
    // 嚴重度設定：key = 告警等級(等級)，對應顏色 / 文字 / 排序權重 / 是否預設展開
    sevConfig: function sevConfig() {
      return {
        2: {
          label: '影響發電',
          color: '#d41e1e',
          priority: 0,
          expand: true
        },
        6: {
          label: '系統未連線',
          color: '#6b28d4',
          priority: 1,
          expand: true
        },
        7: {
          label: '系統短暫斷線',
          color: '#c95c10',
          priority: 2,
          expand: true
        },
        9: {
          label: '發電效率不佳',
          color: '#1555c0',
          priority: 3,
          expand: false
        },
        3: {
          label: '不影響發電',
          color: '#c07800',
          priority: 4,
          expand: false
        }
      };
    },
    // 把已篩選的扁平告警(showFilteredAlertData)依逆變器收折成一組組
    groupedAlarms: function groupedAlarms() {
      var sev = this.sevConfig;
      var prio = function prio(lv) {
        return sev[lv] ? sev[lv].priority : 99;
      };
      var map = new Map();
      var _iterator = _createForOfIteratorHelper(this.showFilteredAlertData),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var it = _step.value;
          var name = it.factoryName || '';
          // 有 inv：同案場同一台收一組；無 inv(整站告警)：各自一組
          var key = it.inv != null ? "".concat(name, "__inv").concat(it.inv) : "".concat(name, "__plant__").concat(it['告警啟動時間'], "__").concat(it['事件']);
          if (!map.has(key)) {
            var _it$inv;
            map.set(key, {
              key: key,
              factoryName: name,
              inv: (_it$inv = it.inv) !== null && _it$inv !== void 0 ? _it$inv : null,
              severity: it['等級'],
              latestTime: it['告警啟動時間'],
              ongoing: false,
              alarms: []
            });
          }
          var g = map.get(key);
          g.alarms.push(it);
          if (prio(it['等級']) < prio(g.severity)) g.severity = it['等級'];
          if (it['告警啟動時間'] > g.latestTime) g.latestTime = it['告警啟動時間'];
          if (it.ongoing) g.ongoing = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return _toConsumableArray(map.values()).sort(function (a, b) {
        return prio(a.severity) - prio(b.severity) || b.latestTime.localeCompare(a.latestTime);
      });
    },
    // 目前顯示總告警筆數（for header）
    visibleAlarmCount: function visibleAlarmCount() {
      return this.groupedAlarms.reduce(function (n, g) {
        return n + g.alarms.length;
      }, 0);
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions(['asyncSpecificLastDoc', 'asyncInfo', 'getAllAlarm'])), mapMutations(['LAST_MON_ACP_IRR', 'UPDATE_DATA_ANALYSIS_STATE', 'RESET_FACTORY_DATA'])), {}, {
    dbDataHandle: dbDataHandle,
    searchChange: function searchChange(searchQuery) {
      this.multipleSearch();
    },
    searchSelect: function searchSelect(selectedOption) {
      this.searchValue.push(selectedOption);
      this.multipleSearch();
    },
    searchRemove: function searchRemove(removedOption) {
      this.searchValue = this.searchValue.filter(function (item) {
        return item !== removedOption;
      });
    },
    // 案場狀態圖示等級：依告警等級權限過濾
    // 受權限管控者(2/3/6/7/9)無權限 → 以正常(0)呈現；0/4/5 非權限管控恆顯示
    gateAlertLevel: function gateAlertLevel(displayAlertLevel) {
      var lvl = displayAlertLevel === 1 ? 2 : displayAlertLevel;
      var gated = [2, 3, 6, 7, 9];
      if (gated.includes(lvl) && !this.hasAlertLevelNumList.includes(lvl)) {
        return 0;
      }
      return displayAlertLevel;
    },
    alertLevelToText: function alertLevelToText(displayAlertLevel) {
      if (displayAlertLevel === 0) return '系統正常營運';
      if (displayAlertLevel === 2) return '發電數據異常';
      if (displayAlertLevel === 3) return '部分通訊異常';
      if (displayAlertLevel === 5) return '資料缺漏回補';
      if (displayAlertLevel === 6) return '系統未連線';
      if (displayAlertLevel === 7) return '系統短暫斷線';
      if (displayAlertLevel === 9) return '發電效率不佳';
    },
    activatedLevelButton: function activatedLevelButton() {
      var _this6 = this;
      var findLevelSum = this.levelButtons.find(function (obj) {
        return _this6.levelSum(obj.level) > 0;
      });
      if (findLevelSum) return [findLevelSum.level];
      return [];
    },
    goToSingleSiteInfo: function goToSingleSiteInfo(displaySiteName, fid, isDemoSite) {
      var _singleData$0$Eff$len, _singleData$0$Eff, _singleData$;
      this.whichFactory = fid;
      var singleData = this.factoryData.filter(function (x) {
        return x.displaySiteName === displaySiteName;
      });
      var invLen = (_singleData$0$Eff$len = (_singleData$0$Eff = singleData[0].Eff) === null || _singleData$0$Eff === void 0 ? void 0 : _singleData$0$Eff.length) !== null && _singleData$0$Eff$len !== void 0 ? _singleData$0$Eff$len : 0;
      var pvLen = singleData[0].pv_a ? Math.max.apply(Math, _toConsumableArray(singleData[0].pv_a.map(function (x) {
        return x.length;
      }))) : singleData[0].mppt_a ? Math.max.apply(Math, _toConsumableArray(singleData[0].mppt_a.map(function (x) {
        return x.length;
      }))) : 0;
      var anemometerLen = Array.isArray(singleData[0].Anemometer) ? singleData[0].Anemometer.length : singleData[0].Anemometer || singleData[0].Anemometer === 0 ? 1 : 0;
      var routerQueryParams = {
        siteName: singleData[0].displaySiteName,
        invLen: invLen,
        pvLen: pvLen,
        anemometerLen: anemometerLen,
        fid: fid,
        demo: isDemoSite ? 'true' : 'false'
      };
      this.toSiteInfo(routerQueryParams);
      this.LAST_MON_ACP_IRR((_singleData$ = singleData[0]) === null || _singleData$ === void 0 ? void 0 : _singleData$.PrRaMon);
      this.UPDATE_DATA_ANALYSIS_STATE();
    },
    toSiteInfo: function toSiteInfo(routerQueryParams) {
      if (this.roleComponentMenu.length) {
        var to = this.roleComponentMenu[0];
        this.$router.push({
          path: "/".concat(i18n.locale, "/siteinfo/").concat(to),
          query: routerQueryParams
        });
      } else {
        this.$swal('權限不足');
        this.$router.push({
          path: "/".concat(i18n.locale, "/realtime")
        });
      }
    },
    openSiteModal: function openSiteModal(openFactoryName, openDisplaySiteName, isDemoSite, openFactoryId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var seq, factoryError, errorArr;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this7.roleOthersMenu[0].hasPermission) {
                  _context.next = 24;
                  break;
                }
                // 取 othersMenu 的第一個 object [ 即時資訊 - 案場狀態告警 ]
                _this7.alertData = [];
                _this7.alertModalNoData = false;
                _this7.modalTitle = openDisplaySiteName;
                _this7.selectTime = DateTime.local().toFormat('yyyy-MM-dd');
                _this7.alertBeginTime = _this7.alertEndTime = _this7.selectTime;
                _this7.alarmQueriedRange = [_this7.selectTime, _this7.selectTime];
                _this7.alertFilterInput = '';
                _this7.alertCurrentPage = 1;
                _this7.openGroups = {};
                _this7.alarmLevelsPending = true;
                _this7.$bvModal.show('siteAlertModal');
                _this7.alertTableLoading = true;
                seq = ++_this7.alarmReqSeq;
                _context.next = 16;
                return getFactoryErrorApi(_this7.selectTime, _this7.selectTime, openFactoryName, openFactoryId);
              case 16:
                factoryError = _context.sent;
                if (!(seq !== _this7.alarmReqSeq)) {
                  _context.next = 19;
                  break;
                }
                return _context.abrupt("return");
              case 19:
                errorArr = factoryError.data.data.filter(function (x) {
                  return x.factoryName === openFactoryName;
                });
                if (errorArr) {
                  errorArr.forEach(function (item) {
                    var _item$inv, _item$pv, _item$alarmKey, _item$category;
                    _this7.alertData.push({
                      告警啟動時間: DateTime.fromISO(item.timestamp).toFormat('yyyy-MM-dd HH:mm:ss'),
                      事件: isDemoSite ? item.desc.replace(openFactoryName, openDisplaySiteName) : item.desc,
                      等級: item.alertLevel === 1 ? 2 : item.alertLevel,
                      factoryName: isDemoSite ? openDisplaySiteName : openFactoryName,
                      inv: (_item$inv = item.inv) !== null && _item$inv !== void 0 ? _item$inv : null,
                      pv: (_item$pv = item.pv) !== null && _item$pv !== void 0 ? _item$pv : null,
                      alarmKey: (_item$alarmKey = item.alarmKey) !== null && _item$alarmKey !== void 0 ? _item$alarmKey : null,
                      類型: (_item$category = item.category) !== null && _item$category !== void 0 ? _item$category : null,
                      ongoing: item.ongoing === true
                    });
                  });
                }
                _this7.alertTableLoading = false;
                _this7.alertModalNoData = _this7.alertData.length === 0;
                _this7.applyDefaultLevelsOnce();
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    openAllModal: function openAllModal() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var seq, factoryError;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this8.alertData = [];
                _this8.selectTime = DateTime.local().toFormat('yyyy-MM-dd');
                _this8.allAlertBeginTime = _this8.allAlertEndTime = _this8.selectTime;
                _this8.alarmQueriedRange = [_this8.selectTime, _this8.selectTime];
                _this8.alertFilterInput = '';
                _this8.alertCurrentPage = 1;
                _this8.alertModalNoData = false;
                _this8.openGroups = {};
                _this8.alarmLevelsPending = true;
                _this8.$bvModal.show('allAlertModal');
                _this8.alertTableLoading = true;
                seq = ++_this8.alarmReqSeq;
                _context2.next = 14;
                return getFactoryErrorApi(_this8.selectTime, _this8.selectTime, 'all', 'all');
              case 14:
                factoryError = _context2.sent;
                if (!(seq !== _this8.alarmReqSeq)) {
                  _context2.next = 17;
                  break;
                }
                return _context2.abrupt("return");
              case 17:
                factoryError.data.data.forEach(function (x) {
                  if (_this8.userDetail.factoriesList.includes(x.factoryName) || _this8.hasAllFactoryPermission) {
                    var _x$inv, _x$pv, _x$alarmKey, _x$category;
                    _this8.alertData.push({
                      告警啟動時間: DateTime.fromISO(x.timestamp).toFormat('yyyy-MM-dd HH:mm:ss'),
                      事件: x.desc,
                      等級: x.alertLevel === 1 ? 2 : x.alertLevel,
                      // alertLevel 若是 1 則併入 2 內 (1 改為 2)
                      factoryName: x.factoryName,
                      inv: (_x$inv = x.inv) !== null && _x$inv !== void 0 ? _x$inv : null,
                      pv: (_x$pv = x.pv) !== null && _x$pv !== void 0 ? _x$pv : null,
                      alarmKey: (_x$alarmKey = x.alarmKey) !== null && _x$alarmKey !== void 0 ? _x$alarmKey : null,
                      類型: (_x$category = x.category) !== null && _x$category !== void 0 ? _x$category : null,
                      ongoing: x.ongoing === true
                    });
                  }
                });
                _this8.alertTableLoading = false;
                _this8.alertModalNoData = _this8.alertData.length === 0;
                _this8.applyDefaultLevelsOnce();
              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    queryModal: function queryModal(querySiteName) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this9$factoryInfo$fi, _this9$factoryInfo$fi2, _this9$factoryInfo$fi3, _this9$factoryInfo$fi4;
        var isQueryAll, isQueryDemo, useQuerySiteName, useQuerySiteId, useQueryStartDate, useQueryEndDate, seq, factoryError, errorArr;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isQueryAll = querySiteName === 'all';
                isQueryDemo = querySiteName.includes('展示案場 ');
                useQuerySiteName = isQueryDemo ? (_this9$factoryInfo$fi = _this9.factoryInfo.filter(function (item) {
                  return item.displaySiteName === querySiteName;
                })) === null || _this9$factoryInfo$fi === void 0 ? void 0 : (_this9$factoryInfo$fi2 = _this9$factoryInfo$fi[0]) === null || _this9$factoryInfo$fi2 === void 0 ? void 0 : _this9$factoryInfo$fi2.factory : querySiteName;
                useQuerySiteId = isQueryAll ? 'all' : (_this9$factoryInfo$fi3 = _this9.factoryInfo.filter(function (item) {
                  return item.factory === useQuerySiteName;
                })) === null || _this9$factoryInfo$fi3 === void 0 ? void 0 : (_this9$factoryInfo$fi4 = _this9$factoryInfo$fi3[0]) === null || _this9$factoryInfo$fi4 === void 0 ? void 0 : _this9$factoryInfo$fi4.factoryId;
                useQueryStartDate = isQueryAll ? _this9.allAlertBeginTime : _this9.alertBeginTime;
                useQueryEndDate = isQueryAll ? _this9.allAlertEndTime : _this9.alertEndTime;
                _this9.alertTableLoading = true;
                _this9.alertData = [];
                _this9.alertModalNoData = false;
                _this9.alertCurrentPage = 1;
                _this9.alarmQueriedRange = [useQueryStartDate, useQueryEndDate];
                seq = ++_this9.alarmReqSeq;
                _context3.next = 14;
                return getFactoryErrorApi(useQueryStartDate, useQueryEndDate, useQuerySiteName, useQuerySiteId);
              case 14:
                factoryError = _context3.sent;
                if (!(seq !== _this9.alarmReqSeq)) {
                  _context3.next = 17;
                  break;
                }
                return _context3.abrupt("return");
              case 17:
                errorArr = isQueryAll ? factoryError.data.data.filter(function (x) {
                  return _this9.userDetail.factoriesList.includes(x.factoryName) || _this9.hasAllFactoryPermission;
                }) : factoryError.data.data.filter(function (x) {
                  return x.factoryName === useQuerySiteName;
                });
                if (errorArr) {
                  errorArr.forEach(function (x) {
                    var _x$inv2, _x$pv2, _x$alarmKey2, _x$category2;
                    _this9.alertData.push({
                      告警啟動時間: DateTime.fromISO(x.timestamp).toFormat('yyyy-MM-dd HH:mm:ss'),
                      事件: isQueryDemo ? x.desc.replace(useQuerySiteName, querySiteName) : x.desc,
                      等級: x.alertLevel === 1 ? 2 : x.alertLevel,
                      factoryName: isQueryDemo ? querySiteName : x.factoryName,
                      inv: (_x$inv2 = x.inv) !== null && _x$inv2 !== void 0 ? _x$inv2 : null,
                      pv: (_x$pv2 = x.pv) !== null && _x$pv2 !== void 0 ? _x$pv2 : null,
                      alarmKey: (_x$alarmKey2 = x.alarmKey) !== null && _x$alarmKey2 !== void 0 ? _x$alarmKey2 : null,
                      類型: (_x$category2 = x.category) !== null && _x$category2 !== void 0 ? _x$category2 : null,
                      ongoing: x.ongoing === true
                    });
                  });
                }
                _this9.alertTableLoading = false;
                _this9.alertModalNoData = _this9.alertData.length === 0;
                _this9.applyDefaultLevelsOnce();
              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    applyDefaultLevelsOnce: function applyDefaultLevelsOnce() {
      // 每次開窗只套一次預設類別：開窗請求若被查詢取代，就由查詢的回應來套；之後的查詢保留使用者選的類別
      if (!this.alarmLevelsPending) return;
      this.alarmLevelsPending = false;
      // 預設顯示類別：進行中的等級全選；無進行中則取最嚴重一個等級
      this.alertFilterLevelNum = this.defaultAlertLevels(this.filteredAlertData);
    },
    endDisabled: function endDisabled(begin, maxDays) {
      var hi = DateTime.min(DateTime.fromISO(begin).plus({
        days: maxDays - 1
      }), DateTime.local()).toISODate();
      return function (d) {
        var t = DateTime.fromJSDate(d).toISODate();
        return t < begin || t > hi;
      };
    },
    beginDisabled: function beginDisabled(end, maxDays) {
      var lo = DateTime.fromISO(end).minus({
        days: maxDays - 1
      }).toISODate();
      return function (d) {
        var t = DateTime.fromJSDate(d).toISODate();
        return t < lo || t > end;
      };
    },
    // 下載畫面目前看到的告警（日期、搜尋字、等級 pill 都套用），不再打一次 Cosmos
    downloadAlarms: function downloadAlarms(title) {
      var _this$alarmQueriedRan = _slicedToArray(this.alarmQueriedRange, 2),
        from = _this$alarmQueriedRan[0],
        to = _this$alarmQueriedRan[1];
      return alarmDownload("".concat(title, "_\u544A\u8B66_").concat(from, "_").concat(to), this.showFilteredAlertData, this.sevConfig);
    },
    toggleAlertLevelBtn: function toggleAlertLevelBtn(levelNum) {
      var hasFilterLevelNum = this.alertFilterLevelNum.includes(levelNum);
      if (hasFilterLevelNum) {
        this.alertFilterLevelNum = this.alertFilterLevelNum.filter(function (item) {
          return item !== levelNum;
        });
      } else {
        this.alertFilterLevelNum.push(levelNum);
      }
    },
    levelSum: function levelSum(num) {
      return this.filteredAlertData.filter(function (item) {
        return item['等級'] === num;
      }).length;
    },
    // ---- 告警收折卡片相關 ----
    isGroupOpen: function isGroupOpen(g) {
      // 使用者手動切換過 -> 依 openGroups；否則用嚴重度預設(expand)
      if (Object.prototype.hasOwnProperty.call(this.openGroups, g.key)) {
        return this.openGroups[g.key];
      }
      var cfg = this.sevConfig[g.severity];
      return cfg ? cfg.expand : false;
    },
    toggleGroup: function toggleGroup(g) {
      this.$set(this.openGroups, g.key, !this.isGroupOpen(g));
    },
    // 計算 modal 預設選取等級：有進行中 → 取全部進行中等級；否則取最嚴重一個
    defaultAlertLevels: function defaultAlertLevels(data) {
      var sev = this.sevConfig;
      var ongoingLevels = _toConsumableArray(new Set(data.filter(function (a) {
        return a.ongoing;
      }).map(function (a) {
        return a['等級'];
      })));
      if (ongoingLevels.length) return ongoingLevels;
      var allLevels = _toConsumableArray(new Set(data.map(function (a) {
        return a['等級'];
      }))).sort(function (a, b) {
        var _sev$a$priority, _sev$a, _sev$b$priority, _sev$b;
        return ((_sev$a$priority = (_sev$a = sev[a]) === null || _sev$a === void 0 ? void 0 : _sev$a.priority) !== null && _sev$a$priority !== void 0 ? _sev$a$priority : 99) - ((_sev$b$priority = (_sev$b = sev[b]) === null || _sev$b === void 0 ? void 0 : _sev$b.priority) !== null && _sev$b$priority !== void 0 ? _sev$b$priority : 99);
      });
      return allLevels.length ? [allLevels[0]] : [];
    },
    groupInvLabel: function groupInvLabel(g) {
      if (g.inv == null) return '整站';
      var s = String(g.inv);
      if (/^\d+$/.test(s)) return "\u7B2C".concat(g.inv, "\u53F0");
      // 感測器前綴對照
      var prefixMap = [{
        prefix: 'PVTemp',
        label: '模組溫度'
      }, {
        prefix: 'ENVtemp',
        label: '環境溫度'
      }, {
        prefix: 'IRR',
        label: '日照計'
      }, {
        prefix: 'LV_Meter',
        label: '低壓電錶'
      }, {
        prefix: 'HV_Meter',
        label: '高壓電錶'
      }, {
        prefix: 'MVCB',
        label: '中壓電錶 (MVCB)'
      }];
      var match = prefixMap.find(function (m) {
        return s.startsWith(m.prefix);
      });
      return match ? match.label : s;
    },
    stringSummary: function stringSummary(g) {
      // 串別摘要：去重、排序、連續區間壓縮 ->「第7~13串（共7串）」「第1~2、8串（共3串）」
      var pvs = _toConsumableArray(new Set(g.alarms.map(function (a) {
        return a.pv;
      }).filter(function (v) {
        return v != null;
      }))).sort(function (a, b) {
        return a - b;
      });
      if (!pvs.length) return g.inv == null ? '通訊中斷' : '整機異常';
      var parts = [];
      var s = pvs[0];
      var p = pvs[0];
      for (var i = 1; i <= pvs.length; i++) {
        if (pvs[i] === p + 1) {
          p = pvs[i];
          continue;
        }
        parts.push(s === p ? "".concat(s) : "".concat(s, "~").concat(p));
        s = pvs[i];
        p = pvs[i];
      }
      return "\u7B2C".concat(parts.join('、'), "\u4E32\uFF08\u5171").concat(pvs.length, "\u4E32\uFF09");
    },
    cleanIssue: function cleanIssue(a, g) {
      // 清掉 desc 跟結構欄位重複的部分，只留核心問題描述（防禦式，比不到就原樣）
      var t = a['事件'] || '';
      t = t.replace(/^.*?逆變器\(SN碼:(?:[^()]|\([^()]*\))*\)\s*/, ''); // 去「…逆變器(SN碼: xxx)」前綴
      t = t.replace(/\(第\d+串\)/g, ''); // 去「(第N串)」
      t = t.replace(/，?\s*時間[:：].*$/, ''); // 去「，時間: … 到 …」
      if (g.factoryName) t = t.split(g.factoryName).join('');
      return t.replace(/^[的，、,\s]+/, '').trim() || a['事件'];
    },
    alarmPvLabel: function alarmPvLabel(a) {
      return a.pv != null ? "\u7B2C".concat(a.pv, "\u4E32") : '整機';
    },
    shortTime: function shortTime(t) {
      // t 形如 '2026-06-03 08:15:00' -> 取 HH:mm
      if (!t) return '';
      var parts = t.split(' ');
      return parts[1] ? parts[1].slice(0, 5) : t;
    },
    sevColor: function sevColor(level) {
      var cfg = this.sevConfig[level];
      return cfg ? cfg.color : '#888';
    },
    sevLabel: function sevLabel(level) {
      var cfg = this.sevConfig[level];
      return cfg ? cfg.label : '';
    },
    tbodyTrClass: function tbodyTrClass(item, type) {
      if (!item || type !== 'row') return;
      if (item['等級'] === 2) return 'table-red';
      if (item['等級'] === 3) return 'table-yellow';
      if (item['等級'] === 6) return 'table-grey';
      if (item['等級'] === 7) return 'table-lavender';
      if (item['等級'] === 9) return 'table-blue';
      // if (item['等級'] === 8) return 'table-blue'
    },
    sumValue: function sumValue(v) {
      if (!v.length) return 0;
      var value = dbDataHandle(v.reduce(function (a, b) {
        return a + b;
      }) * 1);
      if (value <= 0) return 0;
      return value;
    },
    handleInvSum: function handleInvSum(v) {
      if (v && v.length) return dbDataHandle(v.reduce(function (a, b) {
        return a + b;
      }));
      return 0;
    },
    alarmCount: function alarmCount(alarmNum) {
      var _this10 = this,
        _this$alarmAmountData,
        _this$alarmAmountData2;
      var includesFactoriesList = function includesFactoriesList(name) {
        return _this10.userDetail.factoriesList.includes(name);
      };
      var includesDemoList = function includesDemoList(name) {
        return _this10.userDetail.demoList.includes(name);
      };

      // 業主
      var isOwner = !this.hasRoleAdmin;
      var useFactories = isOwner ? 'ownerFactories' : 'factories';
      var useAlertCount = isOwner ? 'ownerAlertCount' : 'count';

      // 案場狀態數量 = alarmAmountData 過濾出 (可觀看案場清單 + 展示案場清單) 的數量
      var selectedAlarmNumFactories = (_this$alarmAmountData = this.alarmAmountData[alarmNum]) === null || _this$alarmAmountData === void 0 ? void 0 : _this$alarmAmountData[useFactories];
      var alarmCountFactories = this.hasAllFactoryPermission ? (_this$alarmAmountData2 = this.alarmAmountData[alarmNum]) === null || _this$alarmAmountData2 === void 0 ? void 0 : _this$alarmAmountData2[useAlertCount] : selectedAlarmNumFactories === null || selectedAlarmNumFactories === void 0 ? void 0 : selectedAlarmNumFactories.filter(includesFactoriesList).length;
      var alarmCountDemos = selectedAlarmNumFactories === null || selectedAlarmNumFactories === void 0 ? void 0 : selectedAlarmNumFactories.filter(includesDemoList).length;
      if (alarmCountFactories || alarmCountDemos) {
        return alarmCountFactories + alarmCountDemos;
      }
      return 0;
    },
    // changeTableMode () {
    //   this.tableMode = !this.tableMode
    //   this.headColor = this.tableMode ? 'dark' : 'light'
    // },
    calculatePR: function calculatePR(cap, acp, IRR) {
      if (cap && !isNaN(acp) && !isNaN(IRR)) {
        var sumCap = cap.reduce(function (a, b) {
          return a + b;
        });
        var powerHour = dbDataHandle(acp / sumCap);
        var irr = dbDataHandle(IRR);
        var PR = dbDataHandle(dbDataHandle(powerHour / irr) * 100, 0);
        if (PR >= 100) PR = 100;
        return PR;
      } else return '-';
    },
    handleIRRArray: function handleIRRArray(irr) {
      var type = Object.prototype.toString.call(irr).slice(8, -1).toLowerCase();
      if (irr === undefined || irr === null) return;
      if (type && type === 'number') return irr;
      if (type && type === 'array') {
        if (irr.includes(null)) return null;
        return irr && irr.length ? parseFloat(irr.reduce(function (a, b) {
          return a + b;
        }).toPrecision(12)) / irr.length : 0;
      }
      if (type && type === 'object') return irr.avg ? irr.avg : 0;
    },
    handleInHundred: function handleInHundred(num) {
      if (num >= 100) {
        return 100;
      } else {
        return num;
      }
    },
    backTop: function backTop() {
      var element = document.getElementById(this.filterSearch[0].factoryId);
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    },
    handleResize: function handleResize() {
      // console.log('缩放比例:', window.devicePixelRatio)
      // 瀏覽器視窗大小縮放 或 Ctrl +/-
      // 資料高度小於視窗高度 以致於沒有 scroll 可以往下捲再繼續載入資料
      var viewHeight = this.$refs.refScroll.clientHeight;
      var contentHeight = this.$refs.refTitle.clientHeight + this.$refs.refFilterBar.clientHeight + this.$refs.refData.clientHeight;
      var hasScroll = viewHeight < contentHeight;
      if (!hasScroll) return this.getSplitFactoryData();
    },
    getRealTimeData: function getRealTimeData() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var howMuch, noExistFactory, loadArray;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this11.RESET_FACTORY_DATA();
                howMuch = 10;
                if (!_this11.exitFunction) {
                  _context4.next = 4;
                  break;
                }
                return _context4.abrupt("return");
              case 4:
                if (!(_this11.$router.history.current.name === 'realtime')) {
                  _context4.next = 10;
                  break;
                }
                noExistFactory = _this11.factoryInfo.filter(function (y) {
                  return !_this11.factoryData.map(function (x) {
                    return x.displaySiteName;
                  }).includes(y.displaySiteName);
                });
                loadArray = noExistFactory.filter(function (_, index) {
                  return index < howMuch && index >= 0;
                });
                if (!(loadArray.length > 0)) {
                  _context4.next = 10;
                  break;
                }
                _context4.next = 10;
                return _this11.loadSearch(loadArray);
              case 10:
                _this11.alertLevelSelectDisAble = false;
              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getAllData: function getAllData() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var noExistFactory;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                noExistFactory = _this12.factoryInfo.filter(function (y) {
                  return !_this12.factoryData.map(function (x) {
                    return x.displaySiteName;
                  }).includes(y.displaySiteName);
                });
                _context5.next = 3;
                return _this12.loadSearch(noExistFactory);
              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    loadMore: function loadMore(e) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this13.clientTop = e.target.scrollTop === 0;
                if (!(Math.abs(e.target.clientHeight + e.target.scrollTop - e.target.scrollHeight) <= 10)) {
                  _context6.next = 4;
                  break;
                }
                _context6.next = 4;
                return _this13.getSplitFactoryData();
              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    getSplitFactoryData: function getSplitFactoryData() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var noExistFactory, loadArray;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this14.exitFunction || _this14.isLoadingData || _this14.searchValue.length !== 0 || _this14.selectedAlert !== null)) {
                  _context7.next = 2;
                  break;
                }
                return _context7.abrupt("return");
              case 2:
                if (!(_this14.$router.history.current.name === 'realtime' && !_this14.isLoadingData)) {
                  _context7.next = 8;
                  break;
                }
                noExistFactory = _this14.factoryInfo.filter(function (y) {
                  return !_this14.factoryData.map(function (x) {
                    return x.displaySiteName;
                  }).includes(y.displaySiteName);
                });
                loadArray = noExistFactory.filter(function (_, index) {
                  return index < 10 && index >= 0;
                });
                if (!(loadArray.length > 0)) {
                  _context7.next = 8;
                  break;
                }
                _context7.next = 8;
                return _this14.loadSearch(loadArray);
              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    multipleSearch: function multipleSearch() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var filterInput;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this15.isLoadingData || !_this15.searchValue.length)) {
                  _context8.next = 2;
                  break;
                }
                return _context8.abrupt("return");
              case 2:
                // filter Info 有找到 searchValue 且 不在展示的 Data 內
                filterInput = _this15.factoryInfo.filter(function (info) {
                  return info.displaySiteName.includes(_this15.searchValue.at(-1));
                }).filter(function (info) {
                  return !_this15.factoryData.map(function (data) {
                    return data.displaySiteName;
                  }).includes(info.displaySiteName);
                });
                if (!filterInput.length) {
                  _context8.next = 6;
                  break;
                }
                _context8.next = 6;
                return _this15.loadSearch(filterInput);
              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    // 點狀態 chip 篩選；點同一顆或「清除篩選」就取消，沿用原本下拉選單的流程
    toggleStatus: function toggleStatus(level) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var value;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                value = level === null || _this16.selectedAlert === String(level) ? '' : String(level);
                _this16.selectedAlert = value;
                _context9.next = 4;
                return _this16.factoryAlertSearch(value);
              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    factoryAlertSearch: function factoryAlertSearch(value) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(_this17.selectedAlert !== '')) {
                  _context10.next = 5;
                  break;
                }
                _this17.alertLevelSelectDisAble = true;
                _context10.next = 4;
                return _this17.getFactoriesByAlert(value);
              case 4:
                _this17.alertLevelSelectDisAble = false;
              case 5:
                if (_this17.selectedAlert === '') {
                  _this17.selectedAlert = null;
                }
              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    getFactoriesByAlert: function getFactoriesByAlert(value) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this18$alarmAmountDa, _this18$alarmAmountDa2;
        var isOwner, useFactories, factoryByAlertList, alertFactoryList;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // 業主
                isOwner = !_this18.hasRoleAdmin;
                useFactories = isOwner ? 'ownerFactories' : 'factories'; // 可看 ALL or all案場狀態過濾出可看案場+展示案場清單
                factoryByAlertList = _this18.hasAllFactoryPermission ? (_this18$alarmAmountDa = _this18.alarmAmountData[value]) === null || _this18$alarmAmountDa === void 0 ? void 0 : _this18$alarmAmountDa[useFactories] : (_this18$alarmAmountDa2 = _this18.alarmAmountData[value]) === null || _this18$alarmAmountDa2 === void 0 ? void 0 : _this18$alarmAmountDa2[useFactories].filter(function (name) {
                  return _this18.userDetail.factoriesList.includes(name) || _this18.userDetail.demoList.includes(name);
                });
                if (_this18.exitFunction) {
                  _context11.next = 8;
                  break;
                }
                // 從 factoryInfo 取出要 call api 的 {} 們，不包含已呈現在頁面上的 (factoryData)
                alertFactoryList = _this18.factoryInfo.filter(function (y) {
                  return (factoryByAlertList === null || factoryByAlertList === void 0 ? void 0 : factoryByAlertList.includes(y.factory)) && !_this18.factoryData.map(function (x) {
                    return x.factoryName;
                  }).includes(y.factory);
                });
                if (!(alertFactoryList.length > 0)) {
                  _context11.next = 8;
                  break;
                }
                _context11.next = 8;
                return _this18.loadSearch(alertFactoryList);
              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    loadSearch: function loadSearch(array) {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this19.isLoadingData = true;
                _context12.next = 3;
                return _this19.asyncSpecificLastDoc(array);
              case 3:
                _this19.isLoadingData = false;

                // data 載入完畢後，dom 更新後執行 nextTick
                // 資料高度小於視窗高度 以致於沒有 scroll 可以往下捲再繼續載入資料
                // 置於 loadSearch 後，判斷高度 -> 取得資料直到有產生捲軸 則不再執行 loadSearch (nextTick)
                _this19.$nextTick(function () {
                  var viewHeight = _this19.$refs.refScroll.clientHeight;
                  var contentHeight = _this19.$refs.refTitle.clientHeight + _this19.$refs.refFilterBar.clientHeight + _this19.$refs.refData.clientHeight;
                  var hasScroll = viewHeight < contentHeight;
                  if (!hasScroll) return _this19.getSplitFactoryData();
                });
              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    }
  }),
  created: function created() {
    var _this20 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              window.addEventListener('resize', _this20.handleResize);
              _this20.alertLevelSelectDisAble = true;
              _this20.isLoadingData = true;
              _context13.next = 5;
              return _this20.asyncInfo();
            case 5:
              if (!_this20.$store.state.realTimeDataReload) {
                _context13.next = 10;
                break;
              }
              _context13.next = 8;
              return _this20.getRealTimeData();
            case 8:
              _context13.next = 10;
              return _this20.getAllAlarm();
            case 10:
              _this20.isLoadingData = false;
              _this20.alertLevelSelectDisAble = false;
            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }))();
  },
  mounted: function mounted() {
    var _this21 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
      var element;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (!_this21.$store.state.realTimeDataReload) {
                element = document.getElementById(_this21.$store.state.globalFactory);
                if (element) {
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                  });
                }
              }
            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }))();
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this22 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (JSON.parse(localStorage.getItem('userDetail'))) {
                _this22.$store.state.realTimeDataReload = false;
                _this22.$store.state.globalFactory = _this22.whichFactory;
              }
              _this22.exitFunction = true;
              _this22.hasKeepingAlive = true;
              next();
            case 4:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }))();
  },
  // keep-alive lifecycle enter
  // activated 是 keep-alive 範圍內 才有的，一進入頁面執行，離開是執行 deactivated
  // activated 可用於初始化頁面數據
  activated: function activated() {
    var _this23 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
      var element;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              if (!_this23.hasKeepingAlive) {
                _context16.next = 10;
                break;
              }
              // keep-alive 使 RouteLeave 後 exitFunction === true (->不載入資料) 仍然存在
              // activated 後將 exitFunction 回復預設 (false)
              _this23.exitFunction = false;

              // ex: usermanage 更新資料後，回到 realtime 頁
              // 因有緩存(keep-alive)，不再執行 created、mounted (僅剛開始建立時各執行一次)
              // 若有資料更新 (realTimeDataReload === true)，需重新初始化資料
              if (!_this23.$store.state.realTimeDataReload) {
                _context16.next = 9;
                break;
              }
              _this23.multiselectValue = [];
              _this23.selectedAlert = null;
              _context16.next = 7;
              return _this23.getRealTimeData();
            case 7:
              _context16.next = 9;
              return _this23.getAllAlarm();
            case 9:
              if (!_this23.$store.state.realTimeDataReload) {
                element = document.getElementById(_this23.$store.state.globalFactory);
                if (element) {
                  element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                  });
                }
              }
            case 10:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};